import { useCallback } from "react";
import { notification } from "antd";
import { errorToast } from "../utils/toasts";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../Redux Store/Slices/auth";

const useErrorHandler = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate(); // useNavigate hook to navigate

    const handleError = useCallback((error) => {
        console.log({ error: error });
        if (error?.response?.status === 401) {
            errorToast("Session Expired, Please Login Again");
            dispatch(logout());
            navigate("/login");
        }

        let errorMessage = "Something Went Wrong";

        if (Array.isArray(error?.response?.data?.message)) {
            errorMessage = error.response.data.message.join(", ");
        } else if (error?.response?.data?.message) {
            errorMessage = error.response.data.message;
        }

        notification.error({
            message: "Error",
            description: errorMessage,
            duration: 0,
        });
    }, []);

    return handleError;
};

export default useErrorHandler;